

/**
 * Mini_operator.js
 */


document.addEventListener('DOMContentLoaded', function() {

    var isStorage = !!sessionStorage;

    if(isStorage) {

       var isStr = StorageOperator.isNotStorageData('session', 'state' );
       if(isStr) {
            init();
        }else {
            var isStrLo = StorageOperator.isNotStorageData('local', 'state');
            var or34 = isStrLo ? Number(StorageOperator.getStorageData('local', 'state')['or34']): 3;
            var boo = setOr34State(or34);

            init();
        };

    }else {
        alert('お使いのブラウザでは本アプリケーションは正常に動作しません');
    };

}, false);




function setOr34State(val) {

    var stateObj = StorageOperator.makePageStateJson( val );

    var boo = [false, false];
    try {
        boo = StorageOperator.setStorageData( 'session', 'state', stateObj );		
    }catch(exeption) {
        alert('お使いのブラウザでは、本サイトは正常に動作しません');
    };
    return boo[0];
};


var miniOperator;

function init() {
    General_init.init();
    initTherd();
};

function initTherd() {
    
	miniOperator = new MiniOperator();

	document.getElementById('ifra-result').src = './NumbResultNC-mini.html'
};


class MiniOperator {

    constructor() {
        
        this._state = StorageOperator.getStorageData('session', 'state');

        //const resultData = StorageOperator.getStorageData('session', 'nb_result');
        //this._resultDataArr = resultData.array;
        
        this._resultDataArr = allDataObj.result;

        this._hangar = new DataHangarMini( this._resultDataArr );


        this._btStyle = {   trueBg: '#333377',
                                falseBg: '#fcfcfc',
                                trueColor: '#ffffff',
                                falseColor: '#222222'
                            };

        this._rankArray = [ "all", "ten", "one" ];
        this._rankLabelArray = [ "位【 十、一 】", "位【 十 】", "位【 一 】" ];
        this._nowRankIndex = 0;

        this._categArray = [   "jiku", "jyogai", "fuku"   ];
        this._checkBoxIdStr = [ 'btS', 'btJ', 'btF' ];

        this._resultTableIsGeneral = false;

        this._checkBoxMap = {

            all: {
                jiku: new CheckBox_mini("jiku", "all"),
                jyogai: new CheckBox_mini("jyogai", "all"),
                fuku: new CheckBox_mini("fuku", "all")
            },
            ten: {
                jiku: new CheckBox_mini("jiku", "ten"),
                jyogai: new CheckBox_mini("jyogai", "ten"),
                fuku: new CheckBox_mini("fuku", "ten")
            },
            one: {
                jiku: new CheckBox_mini("jiku", "one"),
                jyogai: new CheckBox_mini("jyogai", "one"),
                fuku: new CheckBox_mini("fuku", "one")
            }
        };
        this._nowRankCheckBoxObj = this._checkBoxMap[this._rankArray[this._nowRankIndex]];

        //
        this._SELECTBT_COLOR0 = { numb: 0,  back: [ 'rgb(25,90,245)', 'rgb(92,168,239)' ],  text: [  '#ffffff', '#eeeeff'  ]  };
		this._SELECTBT_COLOR1 = { numb: 1,  back: [ 'black', 'rgb(50,50,50)' ],  text: [  '#ffffff', '#eeeeff'  ]   };
		this._SELECTBT_COLOR2 = { numb: 2,  back: [ '#8888aa', 'rgb(230, 230, 245)' ],  text: [  '#111111', '#111133'  ]  };

		this._selectBtColorArray = [   this._SELECTBT_COLOR0, this._SELECTBT_COLOR1, this._SELECTBT_COLOR2   ];


		//  テーマ
		this._SELECTBT_COLOR = this._state.theme ? this._selectBtColorArray[this._state.theme] : this._selectBtColorArray[0];
		this._setColor();
        this._canvasViewObj = new CanvasView( this._SELECTBT_COLOR.numb );
        
		this.allEventAddSelectView();

        this._allEventAdd();

        this._nowGeneralTableView();
        this.setAllBtStyle();
        this._nowCategCheckResultTableView();
        this._resultTableView();
        this._canvasViewProcess();
        

    };

    _canvasViewProcess() {
        this._canvasViewObj.setPup3ObjDataDeploy( this._makeCanvasUseObj() );
		this._canvasViewObj.paintAll();
    };

    _makeCanvasUseObj() {
    
		let canvasViewUseObj = {};

        canvasViewUseObj.booArray = this._makeNowBooArray();
		canvasViewUseObj.booDefArray = this._hangar.getDefBooArrayForList( this._makeCheckStateObjList() );

        canvasViewUseObj.totalDefCt = this._booArrayCount( canvasViewUseObj.booDefArray );
		canvasViewUseObj.predData = this._hangar.makePredictData( canvasViewUseObj.booArray, canvasViewUseObj.totalDefCt);
		
		return canvasViewUseObj;
    };
    _booArrayCount(booArray) {

        let count = 0;
        booArray.forEach((val)=> count += val ? 1 : 0);
        return  count;
    };


    _makeNowBooArray() {
        let stateObjList = [];
        for(let i=0, n=this._categArray.length; i<n; i++) {
            let checkBox = this._nowRankCheckBoxObj[this._categArray[i]];
            stateObjList.push( checkBox.makeMiniObj() );
        };
        return this._hangar.getBooArrayForList(stateObjList);
    };


    _makeCheckStateObjList(isRankPafe=false) {
        let stateObjList = [];
        if(isRankPafe) {

        }else {
            for(let i=0, n=this._categArray.length; i<n; i++) {
                let checkBox = this._nowRankCheckBoxObj[this._categArray[i]];
                stateObjList.push( checkBox.makeMiniObj() );
            };
        };
        return stateObjList;
    };
    _makeResultTotalList(stateObjList) {
        return this._hangar.getTotalResultList(stateObjList);
    };

    _makeResultGeneralTotalList() {
        let stateObjList = [];
        for(let i=0, n=this._rankArray.length; i<n; i++) {
            for(let j=0, m=this._categArray.length; j<m; j++) {
                let checkBox = this._checkBoxMap[this._rankArray[i]][this._categArray[j]];
                stateObjList.push( checkBox.makeMiniObj() );
            };  
        };
        return this._makeResultTotalList(stateObjList);
    };



    _allEventAdd() {

		for(let i=0; i<10; i++) {
			MyUtility.setElementEvent( 'btS'+i, 'click', () => this.checkBtClick(this._categArray[0], i), false );
		};
		for(let i=0; i<10; i++) {
			MyUtility.setElementEvent( 'btJ'+i, 'click', () => this.checkBtClick(this._categArray[1], i), false );
		};
		for(let i=0; i<10; i++) {
			MyUtility.setElementEvent( 'btF'+i, 'click', () => this.checkBtClick(this._categArray[2], i), false );
        };

        for(let i=0; i<3; i++) {
			MyUtility.setElementEvent( 'chRt'+i, 'click', () => this.checkBoxRt(i), false );
		};

		MyUtility.setElementEvent( 'rankBt', 'click', () => this.rankChange(), false );

        MyUtility.setElementEvent( 'resultTable-bt', 'click', () => this.resultTableTypeChange(), false );

        //  nav focusDown
        if ("ontouchstart" in window) {
			MyUtility.setElementEvent('navData-down', 'click', MyUtility.buttonDownProcess( 'nav-pull-ul', false), false);
		}else {
	
			MyUtility.focusDownProcess( 'navData-down-li', 'nav-pull-ul' );
		};
        //  insertHelp on off
		let helpNodes = document.getElementsByClassName('insertHelp');
		MyUtility.setElementEvent( 'help-show-bt', 'click', MyUtility.buttonDownProcessNodeArray( helpNodes, true), false );
		let textArray = [ '説明 ON', '説明 OFF' ];
        MyUtility.setElementEvent('help-show-bt', 'click', MyUtility.buttonTextChenge( 'help-show-bt', textArray), false);
        
    };

    rankChange() {
        this._nowRankIndex = ++this._nowRankIndex%this._rankArray.length;
        this._nowRankCheckBoxObj = this._checkBoxMap[this._rankArray[this._nowRankIndex]];

        MyUtility.setElementText('rankBt', this._rankLabelArray[this._nowRankIndex]);
        MyUtility.setElementText('checkBox-th', this._rankLabelArray[this._nowRankIndex]);
        MyUtility.setElementText('resultTable-th', this._rankLabelArray[this._nowRankIndex]);

        this._nowGeneralTableView();
        this.setAllBtStyle();
        this._nowCategCheckResultTableView();
        this._resultTableIsGeneral = false;
        this._resultTableView();
        this._canvasViewProcess();
    };


    checkBtClick(categ, index) {
        const checkBox = this._nowRankCheckBoxObj[categ];
        checkBox.click(index);
        if(categ==="jiku" || categ==="fuku") {
            this._nowRankCheckBoxObj["jyogai"].bindArray( checkBox.boxBooArr );
        }else if(categ==="jyogai"){
            this._nowRankCheckBoxObj["jiku"].bindArray( checkBox.boxBooArr );
            this._nowRankCheckBoxObj["fuku"].bindArray( checkBox.boxBooArr );
        };

        this._nowGeneralTableView();
        this.setAllBtStyle();
        this._nowCategCheckResultTableView();
        this._resultTableView();
        this._canvasViewProcess();
    };
    checkBoxRt(val) {
        const checkBox = this._nowRankCheckBoxObj[this._categArray[val]];
        checkBox.clear();

        this._nowGeneralTableView();
        this.setAllBtStyle();
        this._nowCategCheckResultTableView();
        this._resultTableView();
        this._canvasViewProcess();
	};

    setAllBtStyle() {
		for(let i=0, n=this._categArray.length; i<n; i++) {
			let checkBox = this._nowRankCheckBoxObj[this._categArray[i]];
			let boxBooArr = checkBox.boxBooArr;

			for(let j=0, m=boxBooArr.length; j<m; j++) {
				this.setElementColorStyle( this._checkBoxIdStr[i]+j, this._btStyle, boxBooArr[j]);
			};
		};
    };
    
    setElementColorStyle(idStr, styleObj, boo=true) {
		let style = document.getElementById(idStr).style;
		if(boo) {
			style.background = styleObj.trueBg;
			style.color = styleObj.trueColor;
		}else {
			style.background = styleObj.falseBg;
			style.color = styleObj.falseColor;
		};
	};

    _nowGeneralTableView() {

        for(let i=0, n=this._rankArray.length; i<n; i++) {
            for(let j=0, m=this._categArray.length; j<m; j++) {
                let checkBox = this._checkBoxMap[this._rankArray[i]][this._categArray[j]];
                let text = MyUtility.arrayToString( checkBox.getTrueNumerArray() );
                MyUtility.setElementText( this._categArray[j]+'-'+this._rankArray[i], text );
            };
        };

        //
        let size = this._makeResultGeneralTotalList().length;
		MyUtility.setElementText( 'now-general-result', `${size} / ${100}` );

    };


    _nowCategCheckResultTableView() {

		for(let i=0; i<this._categArray.length; i++) {
			let checkBox = this._nowRankCheckBoxObj[this._categArray[i]];
			let text = MyUtility.arrayToString( checkBox.getTrueNumerArray() );
			MyUtility.setElementText( this._categArray[i], text );
		};
        //
        let size = this. _makeResultTotalList(this._makeCheckStateObjList()).length;
		MyUtility.setElementText( 'nowState', `${size} / ${100}` );

    };

    resultTableTypeChange() {
        this._resultTableIsGeneral = this._resultTableIsGeneral ? false : true;
        if(this._resultTableIsGeneral) {
            MyUtility.setElementText('resultTable-th', '統合結果');
        }else {
            MyUtility.setElementText('resultTable-th', this._rankLabelArray[this._nowRankIndex]);
        };
        this._resultTableView(this._resultTableIsGeneral);
    };

    _resultTableView(isRankPafe=false) {

        if(isRankPafe) {
            
            let list = this._makeResultGeneralTotalList();
            this._setTextArray( 'resultTable-tr', list);
        }else {
            let list = this._makeResultTotalList(this._makeCheckStateObjList());
            this._setTextArray( 'resultTable-tr', list);
        };
    };
    _setTextArray(nodeId, array, textType='a') {
        const tr = document.getElementById(nodeId);
        const td = document.createElement('td');
        for(let i=0, n=array.length; i<n; i++) {
            const text = document.createElement(textType);
            text.textContent = i===(n-1) ? array[i] : array[i]+', ' ; 
            td.appendChild( text );
        };
        tr.replaceChild( td, tr.firstChild );
    };


    //
    _setColor() {
		this._setCenterLiColor();
	};
	_setCenterLiColor() {
		for(let i=0; i<3; i++) {
			MyUtility.setElementStyle( 'centerLi_'+i, 'backgroundColor', this._SELECTBT_COLOR.back[1] );
			MyUtility.setElementStyle( 'centerLi_'+i, 'border-color', this._SELECTBT_COLOR.text[1] );
		};

		MyUtility.setElementStyle( 'bt-theme', 'backgroundColor', this._SELECTBT_COLOR.back[1] );
		MyUtility.setElementStyle( 'bt-theme', 'border-color', this._SELECTBT_COLOR.text[1] );
		MyUtility.setElementStyle( 'bt-theme', 'color', this._SELECTBT_COLOR.text[1] );
	};

	//  テーマ変更
	themeChange() {

		for(let i=0, n=this._selectBtColorArray.length; i<n; i++) {
			if( this._SELECTBT_COLOR.numb === i ) {
				this._SELECTBT_COLOR = this._selectBtColorArray[(i+1)%n];
				break;
			};
		};
	
		this._setColor();
		this._canvasViewObj.themeChange();
	
		let boo = [true, true];
		try {
			boo = StorageOperator.storageSetProperty( 'theme', this._SELECTBT_COLOR.numb );
		}catch(exeption) {
			alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};
    };
    allEventAddSelectView() {
		MyUtility.setElementEvent( 'opre_view', 'click', () => this.viewRangeChange(), false );
		MyUtility.setElementEvent( 'bt-theme', 'click', () => this.themeChange(), false );
    };
    viewRangeChange() {
		this._canvasViewObj.canvasViewRangeChange();
	};


};


//  checkBox 
class CheckBox_mini {

	constructor(categ, rank) {

        this._categ = categ;
        this._rank = rank;

        this._size = 10;
        this._max = 1;
        this._is = true;
        if(categ==="jiku") {

        }else if(categ==="jyogai") {
            this._max = 7;
            this._is = false;
        }else if(categ==="fuku") {
            this._max = 7;
        };
		
        this._checkBox = new CheckBoxController( this._size, this._max);
        
	};

	get boxBooArr() {   return this._checkBox.boxBooArr;   }

	getIndexBoo(index) {
		return this._checkBox.boxBooArr[index];
	};

	get bit() {   return this._checkBox.bit;   };

	getTrueNumerArray() {
		return this._checkBox.getTrueNumerArray();
	};

	setStateObj(obj) {

		let bit = obj.bit;
		this._checkBox.boxBooArr = this._bitToArray(bit, 10);
	}


	miniObj() {    };

	makeMiniObj() {

		let obj = {};
        obj.categ = this._categ;
        obj.rank = this._rank;
		obj.is = this._is;
		obj.bit = this._checkBox.bit;

		return obj;
	};


	click(index) {
        this._checkBox.click(index);
	};

	clear() {
		this._checkBox.clear();
	};

	bindArray(booArray) {

		this._checkBox.bindArray(booArray);
	};

	_bitToArray(bit, size) {
		let booArr = new Array(size);
		for(let i=0; i<size; i++) {
			if( (Math.pow(2,i) & bit) > 0 ) {
				booArr[i] = true;
			}else {
				booArr[i] = false;
			};
		};
		return booArr;
    };

};




	/* class canvasView */

class CanvasView {

    constructor(themeIndex) {
        
        this._canvas1 = document.getElementById( 'canvas1' );
        this._canvas2 = document.getElementById( 'canvas2' );
        this._canvas3 = document.getElementById( 'canvas3' );
    
        this.allEventAdd();
    
        this._PRED_SIZE = [];
        this._PRED_RANGE = [ 5, 10, 20, 50 ];
        this._VIEW_USE_PRED_SIZE = [ 3, 4, 5, 6, 9 ];
    
        this._VIEW_RANGE = [  480, 470, 460  ];
    
        this._canvasArrayOffsetDef = 480;
        this._canvasViewRange = 500-this._canvasArrayOffsetDef;
    
        this._canvasArrayOffset = this._canvasArrayOffsetDef;
    
        this._rightNodeState = 0;
    
    
            //  テーマ
        this._THEME_0 = { numb: 0,  white: 'white', back: 'rgba(92,168,239,1)', gradaB: [ 92,168,239 ],
                                    gradaItv: [ 32, 17, 3 ], back2: 'rgb(62, 148, 242)', graphBack: 'rgba(105, 188, 255, 0.85)',
                                    strokeLine: 'rgba(5, 25, 255, 0.8)', strokeGraphF: 'rgba(37, 53, 111, 0.95)',
                                    graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                                    movingA_S: 'rgb(210, 85, 10)',  movingA_M: 'rgb( 255, 255, 255)',
                                    movingA_L: 'rgb(255,255,0)'  };
    
        this._THEME_1 = { numb: 1,  white: 'white', back: 'rgba(50,50,50,1)', gradaB: [ 50,50,50 ],
                                    gradaItv: [ 40, 40, 40 ], back2: 'rgb(25, 25, 25)', graphBack: 'rgba(70, 70, 70, 1)',
                                    strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(5, 5, 5, 1)',
                                    graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                                    movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
                                    movingA_L: 'rgb(230,230,0)'  };
    
        this._THEME_2 = { numb: 2,  white: 'rgb(30,30,30)', back: 'rgba(230,230,245,1)', gradaB: [ 240,240,255 ],
                                    gradaItv: [ -48, -48, -50 ], back2: 'rgb(215, 215, 235)', graphBack: 'rgba(180, 180, 200, 1)',
                                    strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(145, 145, 205, 1)',
                                    graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                                    movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
                                    movingA_L: 'rgb(255,255,0)'  };
    
        this._themeArray = [   this._THEME_0, this._THEME_1, this._THEME_2   ];
        this._THEME = this._themeArray[ themeIndex ];
        this._setThemeColor();   
        
    };
        
    get canvasViewRange() {   return 500-this._canvasArrayOffsetDef;   }
        
    set canvasArrayOffsetDef(val) {
    
        this._canvasArrayOffsetDef = val;
        this._canvasArrayOffset = this._canvasArrayOffsetDef;
        this.paint( this._canvasArrayOffsetDef, 'canvas1' );
    };
        
        
    _setThemeColor() {
        
        this._styleWhite = this._THEME.white;
        this._fillStyleBack = this._THEME.back;
        this._gradationBase = this._THEME.gradaB;
        this._gradationItv = this._THEME.gradaItv;
    
        this._fillStyleBack2 = this._THEME.back2;
        this._fillStyleGraphBack = this._THEME.graphBack;
    
        this._strokeStyleLine = this._THEME.strokeLine;
    
        this._strokeStyleCenterGraphFrame = this._THEME.strokeGraphF;
        this._fillStyleCenterGraphUp = this._THEME.graphUp;
        this._fillStyleCenterGraphDown = this._THEME.graphDown;

        this._movingA_S = this._THEME.movingA_S;
        this._movingA_M = this._THEME.movingA_M;
        this._movingA_L = this._THEME.movingA_L;
    
    };
        
    setPup3ObjDataDeploy(pup3SelectObj) {
        
        this._pup3Obj = pup3SelectObj;
    
        this._booArray = this._pup3Obj.booArray;
    
        this._PRED_SIZE = [5, 10, 20, 50, 100, 200, 500, 1000, 2000, this._booArray.length];
    
        this._indexStart = this._booArray.length-500;
        this._booArr500 = this._booArray.slice(this._booArray.length-500);
        this._booArr500Itv5 = MyUtility.booArrayIntervalCount(this._booArr500, 5);
    
        this._totalCountArray = [  this._pup3Obj.totalDefCt, this._pup3Obj.booDefArray.length ];
    
        this._percent = this._pup3Obj.predData.get('percent');
    
        this._thV = this._pup3Obj.predData.get('theoryVal');
        this._errThV = this._pup3Obj.predData.get('errThVal');
        this._resultCt = this._pup3Obj.predData.get('resultCt');
        this._thGap = this._pup3Obj.predData.get('thValCountGap');
    
        this._predSizeUse = [];
        this._thVUse = [];
        this._errThVUse = [];
        this._resultCtUse = [];
        this._thGapUse = [];
    
        for(let i=0, useSize=this._VIEW_USE_PRED_SIZE, n=useSize.length; i<n; i++) {
            this._predSizeUse.push( this._PRED_SIZE[ useSize[i] ] );
            this._thVUse.push( Math.round( this._thV[ useSize[i] ] ) );
            this._errThVUse.push( this._errThV[ useSize[i] ].toFixed(1) );
            this._resultCtUse.push( this._resultCt[ useSize[i] ] );
            this._thGapUse.push( this._thGap[ useSize[i] ].toFixed(1) );
        };
    
        this._itvMap = this._pup3Obj.predData.get('intervalMap');
    
        this._itvMap5 = this._itvMap.get(5);
        this._itvMap10 = this._itvMap.get(10);
        this._itvMap20 = this._itvMap.get(20);
        this._itvMap50 = this._itvMap.get(50);
    
    }; 

    
    paintAll() {
        
        this.paint( this._canvasArrayOffsetDef, 'canvas1' );
        this.paint2();
        this.paint3( this._rightNodeState );
    };
        
    allEventAdd() {
        
        let itvVal = [ 1, 10, -10, -1 ];
        let start = 'mousedown',   end = 'mouseup';
    
        if ("ontouchstart" in window) {
            start = 'touchstart';      end = 'touchend';
            document.addEventListener("touchcancel", this._canvasTimeE(), false);
        };
        for(let i=0, n=itvVal.length; i<n; i++) {
            MyUtility.setElementEvent( 'opre_bt'+itvVal[i], start, () => this._canvasTimeS(itvVal[i]), false );
            MyUtility.setElementEvent( 'opre_bt'+itvVal[i], end, () => this._canvasTimeE(), false );
        };
    
    
        MyUtility.setElementEvent( 'opre_btRt', 'click', () => this._cvReset(), false );
    
        this._canvas1.addEventListener("wheel", (e) => this.mouseWheelProcess(e) );
    
        MyUtility.setElementEvent( 'change', 'click', () => this.canvasRtChange(), false );
    
    };

        
        
    _windowToCanvas(canvas, x, y) {
        var bbox = canvas.getBoundingClientRect();
        return {  x:  (x - bbox.left) * (canvas.width / bbox.width),
                           y:  (y - bbox.top) * (canvas.height / bbox.height)    };
    };
        
        
    mouseWheelProcess(e) {
        var loc = this._windowToCanvas( this._canvas1, e.clientX, e.clientY);
        if(loc.x > 0 && loc.x <130) {
    
            e.preventDefault();
            if(e.deltaY>0) {
                this._canvasF(2);
            }else {
                this._canvasF(-2);
            };
        };
    };
        
        
        
        
        
    //  canvas ボタン
    _canvasTimeS(val) {
        
        let sig = Math.sign( val );
        let itv = Math.abs( 200/val );
        this._canvasF( sig );
        this._timer = window.setInterval( () => this._canvasF( sig ), itv );
    };
        
    _canvasTimeE() {     window.clearInterval(this._timer);     };
        
        
        
    _canvasF(val) {
        let zz = this._canvasFSub( this._canvasArrayOffset, val);
        this.paint( zz, 'canvas1' );
    };
        
    _canvasFSub( cvArrOffset, val ) {
        
        let zz = ( cvArrOffset + val );
        if(zz<0) {   zz = 0;   };
        if( zz > this._canvasArrayOffsetDef ) {   zz = this._canvasArrayOffsetDef;   };
        this._canvasArrayOffset = zz;
        
        return zz;
    };
        
        
        
        
    //  this._canvasArrayOffset  リセット
    _cvReset() {
        
        this._canvasArrayOffset = this._canvasArrayOffsetDef;
    
        this.paint( this._canvasArrayOffset, 'canvas1' );
    };
    
    
    _zzChangeBtColor( zz ) {
    
        let def = this._canvasArrayOffsetDef;
        if( zz === def ) {
            this._zzChangeBtColorSub(  'rgba(0,255,130,0.4)', '#00ff7f', '#ccccef', '#ffffff' );
        }else if(zz===0) {
            this._zzChangeBtColorSub( '#00ff7f', 'rgba(0,255,130,0.4)', '#ffffff', '#ccccef' );
        }else if( ( (def-3)<=zz && zz<=(def-1) ) ||  (1<=zz && zz<=3) ){
            this._zzChangeBtColorSub( '#00ff7f', '#00ff7f', '#ffffff', '#ffffff' );
        };
    };
    _zzChangeBtColorSub( backColor1, backColor2, color1, color2 ) {
        let itvVal = [ 1, 10, -10, -1 ];
        let backColor = [ backColor1, backColor1, backColor2, backColor2 ];
        let color = [ color1, color1, color2, color2 ];
        let btStyle = [];
        for(let i=0; i<4; i++) {
            document.getElementById( 'opre_bt'+itvVal[i] ).style.background = backColor[i];
            document.getElementById( 'opre_bt'+itvVal[i] ).style.color = color[i];
        };
    };
        
        
        
    //  テーマ変更
    themeChange() {
        for(let i=0, n=this._themeArray.length; i<n; i++) {
            if( this._THEME.numb === i ) {
                this._THEME = this._themeArray[(i+1)%n];
                break;
            };
        };
        this._setThemeColor();
        this.paintAll();
    };
    
    canvasViewRangeChange() {
    
        for(let i=0, n=this._VIEW_RANGE.length; i<n; i++) {
            if(this._VIEW_RANGE[i]===this._canvasArrayOffsetDef) {
                this.canvasArrayOffsetDef = this._VIEW_RANGE[(i+1)%n];
                break;
            };
        };
    };
        
        
        
        
    //   paint
        
    paint(zz, cv) {
        
        this._zzChangeBtColor( zz );
    
        let canvas = document.getElementById( cv );
    
        if (canvas.getContext) {
    
            let context = canvas.getContext('2d');
    
            //  画面クリア
            context.fillStyle = this._fillStyleBack;
            context.fillRect(0, 0, 280, 450);
    
            //  枠
            context.strokeStyle = this._styleWhite;
            context.strokeRect(5, 5, 130, 400);
    
            context.strokeRect(182, 200, 96, 205);
    
    
            //テキスト描画のスタイルを指定
            context.fillStyle = this._styleWhite;
            context.font = "13px 'Meiryo'";
            context.textAlign = "left";
            context.textBaseline = "top";
    
            //  オフセットブロック size
            let offsetBkSize = this.canvasViewRange/500*400;
            //  左オフセットブロック
            context.fillRect(120, 6+zz*0.8, 7, offsetBkSize);
            //  右オフセットブロック
            context.fillRect(165, 5+Math.floor(zz/5)*4, 7, offsetBkSize);
            //
            let arr = this._booArr500;
            let indStart = this._indexStart;
    
            this._leftViewPaint(context, zz, arr, indStart);
    
    
            context.font = "13px 'Meiryo'";
            context.fillText((indStart+501)+"           ?", 10, 415, 165);
            context.fillRect(70, 417, 15, 15);
    
            //
            context.font = "14px 'Meiryo'";
    
            context.fillRect(190, 241, 15, 15);
            context.fillText("率", 216, 239, 20);
    
            context.fillText( this._percent+"%", 230, 260, 60);
    
            context.fillText( "残数", 190, 330, 40);
    
            context.textAlign = "center";
    
            for(let i=0, n=this._totalCountArray.length; i<n; i++) {
                let bar = 0.5;
                context.fillText( this._totalCountArray[i], 243, 320+(i*21)+bar, 50);
            };
    
            //
            context.beginPath();
            context.moveTo(221, 340.5);
            context.lineTo(265, 340.5);
    
            context.stroke();
            context.closePath();
            //
    
    
    
            let arrayMeta = this._booArr500Itv5;
            for(let i=0; i<arrayMeta.length; i++) {
                let ct = arrayMeta[i];
    
                this._paintRect(ct, context);
    
                context.fillRect(145, 5+i*4, 15, 4);
            };
    
            for(let i=0; i<6; i++) {
    
                this._paintRect(i, context);
    
                context.fillRect(180, 19.5+i*20, 15, 10);
    
                context.fillStyle = this._styleWhite;
                context.fillText(i, 207, 14+i*20, 16);
            };
            context.strokeRect(179.5, 19, 16, 11);
                //
        };
    };
    
    _leftViewPaint( context, zz, arr, indStart ) {
    
        let range = this.canvasViewRange;
        let boxRange = 400/range;
        let big = boxRange*0.75;
        let sml = boxRange*0.15;
        let bigG = (boxRange-big)/2;
        let smlG = (boxRange-sml)/2;
    
        let rangeX = boxRange/2;
    
        let fontSizeSub = range/50;
        let fontSize = Math.floor(boxRange*(0.25+fontSizeSub));
    
        context.font = fontSize+"px 'Meiryo'";
    
        for(let i=0; i<range; i++) {
    
            context.fillText((i+zz+indStart+1), 10, 4.5+i*boxRange, 55);
    
            if(arr[i+zz]==0) {
                context.fillRect(78+smlG-rangeX, 5+smlG+i*boxRange, sml, sml);
            }else {
                context.fillRect(78+bigG-rangeX, 5+bigG+i*boxRange, big, big);
            };
        };
    };
    
    
    _paintRect(ct, context) {
    
        let rgb = [];
        for(let i=0; i<3; i++) {
            rgb.push( this._gradationBase[i]+(this._gradationItv[i]*ct) );
        };
        context.fillStyle = 'rgba('+rgb[0]+','+rgb[1]+','+rgb[2]+',1)';
    };
    

    paint2() {
        
        var zzCt = new Array();
        for(var i=0, n=this._predSizeUse.length; i<n; i++) {
            zzCt[i] = this._resultCtUse[i] / this._predSizeUse[i]*180;
        };
    
        var canvas = this._canvas2;
        if (canvas.getContext) {
    
            var context = canvas.getContext('2d');
    
            //  画面クリア
            context.fillStyle =  this._fillStyleBack;
            context.fillRect(0, 0, 280, 500);
    
            context.fillStyle = this._fillStyleBack2;
            context.fillRect(50, 300, 225, 40);
            context.fillRect(50, 420, 225, 40);
    
            context.fillStyle = this._fillStyleGraphBack;
            for(var i=0; i<zzCt.length; i++) {
                context.fillRect(60+i*45, 60, 25, 180);
            };
    
            //
            context.beginPath();
            context.strokeStyle = this._strokeStyleLine;
            var ofs = 240-( 180*this._percent/100 );
            context.moveTo(50, ofs);
            context.lineTo(275, ofs);
            context.stroke();
            context.closePath();
            //
    
            context.fillStyle = this._styleWhite;
            context.font = "13px 'Meiryo'";
            context.textAlign = "left";
            context.textBaseline = "top";
    
            for(var i=0; i<zzCt.length; i++) {
                context.fillRect(60+i*45, 60+(180-zzCt[i]), 25, zzCt[i]);
            };
    
            var ofsL = 0;
            for(var i=0, n=this._thVUse.length; i<n; i++) {
                if(i<2) {   ofsL = 3.5;   }else {   ofsL = 0;}
                context.fillText( this._thVUse[i], 60+ofsL+i*45, 10, 30);
            };
            context.fillText( "理値", 10, 10, 40);
    
            for(var i=0, n=this._resultCtUse.length; i<n; i++) {
                if(i<2) {   ofsL = 3.5;   }else {   ofsL = 0;}
                context.fillText( this._resultCtUse[i], 60+ofsL+i*45, 30, 30);
            };
            context.fillText( "実値", 10, 30, 40);
    
            context.fillText( this._percent+"%", 5, ofs-10, 40);
    
            for(var i=0, n=this._predSizeUse.length; i<n; i++) {
                if(i<1) {   ofsL = 3.5;   }else {   ofsL = 0;}
                context.fillText( this._predSizeUse[i], 60+ofsL+i*45, 240, 30);
            };
            context.fillText( "レンジ", 7, 240, 40);
    
            //
            for(var i=0; i<5; i++) {
                context.fillRect(60+i*45, 380, 25, 80);
            };
    
            //
            context.beginPath();
            context.strokeStyle = this._strokeStyleLine;
            context.moveTo(50, 380);
            context.lineTo(275, 380);
            context.stroke();
            context.closePath();
    
            context.fillText( "理値", 10, 372, 40 );
    
            context.fillText( "理差+", 8, 332, 40 );
            context.fillText( "理差 -", 8, 412, 40 );
            //
    
    
            context.strokeStyle = this._strokeStyleCenterGraphFrame;
    
            var errCt = new Array();
            var errCtOver = new Array();
            for(var i=0, n=this._errThVUse.length; i<n; i++) {
    
                errCt[i] = this._thGapUse[i] / this._errThVUse[i]*-40;
                if(errCt[i]>80) {
                    errCt[i] = 80;          errCtOver[i] = 1;
                }else if(errCt[i]<-80) {
                    errCt[i] = -80;          errCtOver[i] = -1;
                }else {
                    errCtOver[i] = 0;
                };
            };
            for(var i=0; i<errCt.length; i++) {
    
                if(errCt[i]<0) {
                    context.fillStyle = this._fillStyleCenterGraphUp;
                    context.fillRect(60+i*45, 380+errCt[i], 25, errCt[i]*-1);
    
                    context.strokeRect(59.5+i*45, 379.5+errCt[i], 26, 81-errCt[i]);
    
                }else if(errCt[i]>0) {
                    context.fillStyle = this._fillStyleCenterGraphDown;
                    context.fillRect(60+i*45, 380, 25, errCt[i]);
    
                    context.strokeRect(59.5+i*45, 379.5+errCt[i], 26, 81-errCt[i]);
                }else {
                    context.strokeRect(59.5+i*45, 379.5, 26, 81);
                };
            };
    
    
            context.fillStyle = this._strokeStyleLine;
            for(var i=0, n=errCtOver.length; i<n; i++) {
                if(errCtOver[i]===1) {
                    context.fillText( 'over', 62+ofsL+i*45, 438, 22);
                }else if(errCtOver[i]===-1) {
                    context.fillText( 'over', 62+ofsL+i*45, 300, 22);
                };
            };
    
    
            context.strokeStyle = this._styleWhite;
            context.strokeRect(50, 300, 225, 160);
    
            context.fillStyle = this._styleWhite;
    
            for(var i=0, n=this._thGapUse.length; i<n; i++) {
                var st = String(this._thGapUse[i]);
                ofsL = 9-(st.length-1)*2.5;
                context.fillText( this._thGapUse[i], 60+ofsL+i*45, 280, 30);
            };
            context.fillText( "差", 18, 280, 40);
    
    
            for(var i=0, n=this._errThVUse.length; i<n; i++) {
                var st = String( this._errThVUse[i] );
                ofsL = 9-(st.length-1)*2.5;
                context.fillText( this._errThVUse[i], 60+ofsL+i*45, 465, 30);
            };
            context.fillText( "理差", 10, 463, 40);
    
        };
    };
        
        
    paint3(val) {
        
        var zz50Ct = new Array();
        var zz20Ct = new Array();
        var zz10Ct = new Array();
        var zz5Ct = new Array();
    
        for(var i=0, n=this._itvMap50.length; i<n; i++) {
            zz50Ct[i] = this._itvMap50[i]/50*120;
            zz20Ct[i] = this._itvMap20[i]/20*120;
            zz10Ct[i] = this._itvMap10[i]/10*120;
            zz5Ct[i] = this._itvMap5[i]/5*120;
        };
    
        let indStart = this._indexStart;
    
        var range50Top = indStart;
        var range20Top = indStart+500-200;
        var range10Top = indStart+500-100;
        var range5Top = indStart+500-50;
    
    
    
        var canvas = document.getElementById( 'canvas3' );
        if (canvas.getContext) {
    
            var context = canvas.getContext('2d');
    
            //  画面クリア
            context.fillStyle =  this._fillStyleBack;
            context.fillRect(0, 0, 280, 450);
    
            if(val==0) {
                this.paint3Sub(context, this._itvMap50, this._thV[3].toFixed(1), zz50Ct, 5 , range50Top, 50);
    
                this.paint3Sub(context, this._itvMap20, this._thV[2].toFixed(1), zz20Ct, 235, range20Top, 20 );
            }else if(val==1) {
                this.paint3Sub(context, this._itvMap10, this._thV[1].toFixed(1), zz10Ct, 5 , range10Top, 10);
    
                this.paint3Sub(context, this._itvMap5, this._thV[0].toFixed(1), zz5Ct, 235, range5Top, 5 );
            }else {

                this.paint3MovingAverage( context, val );
            };
        };
    };
        
    paint3Sub( context ,zz5020Arr, zz52, zzCt, ofsY, rangeTop, range ) {
        
        context.fillStyle = this._fillStyleGraphBack;
        for(var i=0; i<10; i++) {
            context.fillRect(150, 20+i*20+ofsY, 120, 13);
        };
    
        context.strokeStyle = this._styleWhite;
        context.strokeRect(20, 60+ofsY, 90, 110);
    
        context.fillStyle = this._styleWhite;
        context.textAlign = "center";
        context.textBaseline = "top";
    
        context.font = "16px 'Meiryo'";
    
        context.fillText( "間隔. "+range, 65, 75+ofsY, 95);
    
        context.font = "15px 'Meiryo'";
    
        context.fillText( "理論値", 65, 115+ofsY, 60);
        context.fillText( zz52, 65, 137+ofsY, 60);
    
        for(var i=0; i<10; i++) {
            context.fillText( zz5020Arr[9-i], 135, 18+i*20+ofsY, 60);
        };
    
        context.textAlign = "left";
        context.fillText( '~ '+(rangeTop+1)+'回', 48, 18+ofsY, 62);
        context.fillText( rangeTop+range*10+'回 ~', 48, 197+ofsY, 62);
    
    
        //
        context.beginPath();
        context.strokeStyle = this._fillStyleGraphBack;
        context.moveTo(27, 233);
        context.lineTo(280, 233);
        context.stroke();
        //context.closePath();
        //
        context.beginPath();
        context.strokeStyle = this._strokeStyleLine;
        var ofs = 150+( 120 * this._percent / 100 );
        context.moveTo(ofs, 15+ofsY);
        context.lineTo(ofs, 218+ofsY);
        context.stroke();
        //context.closePath();
        //
        for(var i=0; i<10; i++) {
            context.fillRect(150, 20+i*20+ofsY, zzCt[9-i], 13);
        };
    
        context.textAlign = "center";
        context.font = "14px 'Meiryo'";
        context.fillText(range, 266, 2+ofsY, 30);
        context.fillText( zz52, ofs, 2+ofsY, 40);
    
    };

    paint3MovingAverage( context, type ) {

        let arrayS = type==2 ? this.makeWeightedMovingAverage(25, 200, this._booArray) : this.makeExponentialMovingAverage(25, 200, this._booArray);
        let arrayM = type==2 ? this.makeWeightedMovingAverage(100, 200, this._booArray) : this.makeExponentialMovingAverage(100, 200, this._booArray);
        let arrayL = type==2 ? this.makeWeightedMovingAverage(300, 200, this._booArray) : this.makeExponentialMovingAverage(300, 200, this._booArray);

        let maText = type==2 ? "加重" : "独自";
        //
        let ofx = 65;
        let ofy = 30
        let width = 210;
        let height = 400;
        context.fillStyle = this._fillStyleGraphBack;
        context.fillRect(ofx, ofy, width, height);
        context.strokeStyle = this._styleWhite;
        context.strokeRect( ofx, ofy, width, height);

        let per = (this._percent/100);
        let perText = this._percent;

        //  text
        context.fillStyle = this._styleWhite;
        context.textAlign = "left";
        context.font = "13px 'Meiryo'";

        context.fillText( maText, 5, 5, 65);
        context.fillText( "S-25", 65, 435, 30);
        context.fillText( "M-100", 140, 435, 30);
        context.fillText( "L-300", 210, 435, 30);

        context.font = "13px 'Meiryo'";
        context.fillText( 0, 63, 5, 20);
        context.fillText( perText, ofx+width*per-20, 5, 50);
        context.fillText( 100, 255, 5, 25);
        let index = [ -200, -150, -100, -50, 0 ];
        context.textAlign = "center";
        for(let i=0; i<5; i++) {
            let y = Math.round(ofy+height/4*i)-10;
            context.fillText( index[i], 45, y, 40);
        };

        //
        context.lineWidth = 0.5;

        context.strokeStyle = this._strokeStyleLine;
        context.beginPath();
        context.moveTo( Math.round(ofx+width*per), ofy);
        context.lineTo( Math.round(ofx+width*per), height+ofy);
        context.stroke();
        context.strokeStyle = this._styleWhite;
        for(let i=1; i<4; i++) {
            context.beginPath();
            let y = Math.round(ofy+height/4*i);
            context.moveTo( ofx, y);
            context.lineTo( ofx+width, y);
            context.stroke();	
        };
        context.lineJoin = "round";
        context.lineWidth = 1.3;
    
        context.strokeStyle = this._movingA_L;
        context.beginPath();
        context.moveTo(  ofx+arrayL[0]*width, ofy );
        for(let i=1, n=arrayL.length; i<n; i++) {
            context.lineTo( ofx+arrayL[i]*width, ofy+i*2);
        };
        context.stroke();
        context.beginPath();
        context.moveTo( 245+5, 445);
        context.lineTo( 245+20, 445);
        context.stroke();	


        context.strokeStyle = this._movingA_M;
        context.beginPath();
        context.moveTo(  ofx+arrayM[0]*width, ofy );
        for(let i=1, n=arrayM.length; i<n; i++) {
            context.lineTo( ofx+arrayM[i]*width, ofy+i*2);
        };
        context.stroke();
        context.beginPath();
        context.moveTo( 170+5, 445);
        context.lineTo( 170+20, 445);
        context.stroke();	

        context.strokeStyle = this._movingA_S;
        context.beginPath();
        context.moveTo(  ofx+arrayS[0]*width, ofy );
        for(let i=1, n=arrayS.length; i<n; i++) {
            context.lineTo( ofx+arrayS[i]*width, ofy+i*2);
        };
        context.stroke();
        context.beginPath();
        context.moveTo( 95+5, 445);
        context.lineTo( 95+20, 445);
        context.stroke();
    
    };
            
    makeWeightedMovingAverage(range, rate, target) {
    
        let weight = (range+1)*(range/2.0);

        let resultArr = this.makeArray(rate, 0.0);

        for(let i=rate; i>0; i--) {
            let rateIndex = target.length-i;
            for(let j=1; j<=range; j++) {
                if(target[ rateIndex-( range-j ) ]) {  resultArr[rate-i] += j;  }
            };
            resultArr[rate-i] = resultArr[rate-i]/weight;
        };
        return resultArr;
    };
    makeExponentialMovingAverage(range, rate, target) {

        let resultArr = this.makeArray(rate, 0.0);

        let exponentialCount = 0.0;
        for(let i=1; i<=range; i++) {
            exponentialCount += Math.sqrt(i);
        };
        for(let i=rate; i>0; i--) {
            let rateIndex = target.length-i;
            for(var j=1; j<=range; j++) {
                if(target[ rateIndex-( range-j ) ]) {  resultArr[rate-i] += Math.sqrt(j);  }
            };
            resultArr[rate-i] = resultArr[rate-i]/exponentialCount;
        };
        return resultArr;
    };
    makeArray(size, fill) {
        let array = [];
        for(let i=0; i<size; i++) {   array.push(fill);   };
        return array;
    };
        
    
    //
    canvasRtChange() {
        
        var val = this._rightNodeState;
    
        val = ++val%4;

        this._rightNodeState = val;
    
        this.paint3(val);
    };
        
        
        
};